<section id="form-dados-banacario-beneficiario">
  <div id="documento-aditivo-container-header" class="nova-pagina documento-aditivo-container">
    <app-header-documento-final-proposta
      [entidadeProposta]="entidadeProposta"
      [razaoSocialEntidade]="razaoSocialEntidade"
      [codigoProposta]="codigoProposta"
      [vigenciaProposta]="vigenciaProposta"
      [operadoraVM]="operadoraVM"
      [dadosOperadoraCabecalho]="dadosOperadoraCabecalho"></app-header-documento-final-proposta>
  </div>

  <div class="card-content">
    <div class="card-body">
      <div>
        <h4 class="titulo p-1 mb-2" style="background: #ccc; border-radius: 10px">
          <strong>
            {{ tipoPlano }} - Número {{ tipoRegistroProduto }}: {{ ansProduto }} -
            {{ acomadacaoPlano === 'Não Informado' ? '' : acomadacaoPlano }}
          </strong>
        </h4>
        <div *ngIf="!dadosOperadoraCabecalho?.ehInclusaoDependente || heMedSenior">
          <h4
            *ngIf="!isOdonto() || heOdontoPrev"
            class="titulo"
            style="background: black; padding: 0.5rem; border-radius: 10px; color: #fff">
            <ng-container>
              <strong>AUTORIZAÇÃO DE COBRANÇA</strong>
            </ng-container>
          </h4>
        </div>

        <form [formGroup]="formularioDadosBancarios" class="form row form-impressao-dados-bancarios">
          <div class="print-grid-principal w-100">
            <!-- COLUNA ESQUERDA -->
            <div class="print-coluna print-coluna-esquerda">
              <div class="print-card" *ngIf="!dadosOperadoraCabecalho?.ehInclusaoDependente || heMedSenior">
                <div *ngIf="!isOdonto() || heOdontoPrev || heMedSenior" class="row pl-2 pr-2 grid-dados-bancarios">
                  <div class="form-group col-md-2 col-print-2">
                    <label class="label-upper">Agência</label>
                    <input class="form-control line-style" readonly formControlName="agency" />
                  </div>

                  <div class="form-group col-md-2 col-print-2">
                    <label class="label-upper">Dígito</label>
                    <input class="form-control line-style" readonly formControlName="agencyDigit" />
                  </div>

                  <div class="form-group col-md-1 col-print-1">
                    <label class="label-upper">Tipo</label>
                    <input class="form-control line-style" readonly formControlName="tipoConta" />
                  </div>

                  <div class="form-group col-md-3 col-print-3">
                    <label class="label-upper">Banco</label>
                    <input class="form-control line-style" readonly formControlName="bank" />
                  </div>

                  <div class="form-group col-md-2 col-print-2">
                    <label class="label-upper">Conta</label>
                    <input class="form-control line-style" readonly formControlName="account" />
                  </div>

                  <div class="form-group col-md-2 col-print-2">
                    <label class="label-upper">Dígito</label>
                    <input class="form-control line-style" readonly formControlName="accountDigit" />
                  </div>
                </div>

                <div class="p-2 bloco-autorizacao">
                  <ng-container *ngIf="!isOdonto() || heOdontoPrev || heMedSenior">
                    <p class="mb-1 alinhamento-texto-mobile texto-impressao">
                      Eu
                      <b>{{ nomeTitular }}</b>
                      do CPF: {{ cpfTitular }}, autorizo a
                      {{
                        udemo_e_apase
                          ? 'UDEMO SINDICATO ESP ED MAG OFIC EST SAO PAULO | UDEMO,'
                          : 'Géia Administradora de Benefícios,'
                      }}
                      a realizar o débito automático em minha conta bancária todo o 5º dia útil de cada mês, valor
                      {{ totalPlano | currency: 'BRL' : 'R$ ' : '1.2-2' : 'pt-BR' }}
                      referente à mensalidade, conforme descrito abaixo.
                    </p>
                  </ng-container>

                  <p *ngIf="!isOdonto() || heOdontoPrev || heMedSenior" class="texto-impressao">
                    Assinado em {{ dataAssinaturaDadosBancarios || '--' }} às {{ horaAssinaturaDadosBancarios }}, no
                    preenchimento dos dados da proposta.
                  </p>
                </div>
              </div>
            </div>

            <!-- COLUNA DIREITA -->
            <div class="print-coluna print-coluna-direita">
              <div class="row display-container-mobile">
                <div class="col-12">
                  <h4 class="titulo m-1 print-titulo-bloco">
                    <strong>TOTAL DE MENSALIDADES</strong>
                  </h4>

                  <div class="row pl-2 pr-2 mb-2 bloco-mensalidades">
                    <div class="col-md-6 col-md-12-tablet">
                      <div class="table-responsive">
                        <table class="table custom-table tabela-impressao-compacta">
                          <thead>
                            <tr>
                              <th>Beneficiário</th>
                              <th class="text-center">Idade</th>
                              <th class="text-center">Valor</th>
                            </tr>
                          </thead>

                          <tbody>
                            <ng-container *ngFor="let beneficiario of beneficiarios; let i = index">
                              <tr *ngIf="beneficiario.priceValue">
                                <td>{{ beneficiario.name }}</td>
                                <td class="text-center">
                                  {{ calcularIdade(beneficiario.birthDate) }}
                                </td>
                                <td class="text-center">
                                  {{ beneficiario.priceValue | currency: 'BRL' : 'R$ ' : '1.2-2' : 'pt-BR' }}
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="col-md-6 align-self-center col-md-12-tablet">
                      <p
                        class="text-justify alinhamento-texto-mobile texto-impressao"
                        *ngIf="dadosOperadoraCabecalho?.ehInclusaoDependente; else naoEhInclusaoDependente"></p>

                      <ng-template #naoEhInclusaoDependente>
                        <p
                          class="text-justify alinhamento-texto-mobile texto-impressao"
                          *ngIf="!isOdonto() || heOdontoPrev">
                          O Associado declara ter ciência de que o valor da sua primeira mensalidade e a de seu(s)
                          dependente(s) sofrerá alteração caso haja mudança de faixa etária entre a data de assinatura
                          desta proposta e a primeira cobrança.
                        </p>

                        <p
                          *ngIf="isOdonto() || (udemo_e_apase && !heMedSenior)"
                          class="text-justify mt-2 texto-impressao">
                          Este pagamento NÃO corresponde à primeira mensalidade, a qual será cobrada todo 5º dia útil de
                          cada mês, após a vigência da proposta. Exceto para planos com pagamentos antecipados.
                        </p>

                        <p *ngIf="heMedSenior" class="text-justify mt-2 texto-impressao">
                          Este pagamento NÃO corresponde à primeira mensalidade, a qual será cobrada no dia 1º para
                          clientes com vigência no dia 1 e no dia 15 para clientes com vigência no dia 15, valor
                          {{ totalPlano | currency: 'BRL' : 'R$ ' : '1.2-2' : 'pt-BR' }} referente à mensalidade,
                          conforme descrito abaixo.
                        </p>
                      </ng-template>
                    </div>
                  </div>

                  <hr class="ml-1 mr-1 linha-impressao" />
                  <ng-container *ngIf="!heMedSenior">
                    <p *ngIf="!isOdonto()" class="mb-1 ml-1 mr-1 alinhamento-texto-mobile texto-impressao">
                      O beneficiário realiza neste ato o pagamento da taxa de inscrição no valor exposto no quadro
                      abaixo. Este pagamento NÃO corresponde à primeira mensalidade.
                    </p>
                  </ng-container>

                  <ng-container *ngIf="heMedSenior">
                    <p class="mb-1 ml-1 mr-1 alinhamento-texto-mobile texto-impressao">
                      O beneficiário realiza neste ato o pagamento da taxa de inscrição no valor exposto no quadro
                      abaixo. Este pagamento NÃO corresponde à primeira mensalidade, a qual será cobrada no dia 1º para
                      clientes com vigência no dia 1 e no dia 15 para clientes com vigência no dia 15.
                    </p>
                  </ng-container>

                  <div class="row mb-3 justify-content-center cards-valores-impressao">
                    <div class="col-12 col-md-6 border p-1 mb-2 card-valor-impressao">
                      <p class="titulo bold-preto-700 text-center card-valor-titulo">Valor da Taxa de Inscrição</p>
                      <p class="titulo bold-preto-700 text-center mb-1">
                        {{ totalPlanoComTaxa | currency: 'BRL' : 'R$ ' : '1.2-2' : 'pt-BR' }}
                      </p>
                    </div>

                    <div class="col-12 col-md-6 border p-1 mb-2 card-valor-impressao">
                      <p class="titulo bold-preto-700 text-center card-valor-titulo">
                        Valor Recebido pelo Beneficiário
                      </p>

                      <p
                        class="titulo bold-preto-700 text-center mb-1"
                        *ngIf="valorRecebidoPeloBeneficiario; else SemValorRecebido">
                        {{ valorRecebidoPeloBeneficiario | currency: 'BRL' : 'R$ ' : '1.2-2' : 'pt-BR' }}
                      </p>

                      <ng-template #SemValorRecebido>
                        <p class="titulo bold-preto-700 text-center mb-1">R$ 0,00</p>
                      </ng-template>
                    </div>
                  </div>

                  <div
                    class="col-md-12 col-sm-12 mt-1 bloco-vigencia"
                    *ngIf="tipoPropostaTitular != TipoPropostaEnum.PORTABILIDADE">
                    <div class="table-responsive">
                      <!-- MEDSENIOR -->
                      <table *ngIf="heMedSenior" class="table table-bordered tabela-impressao-compacta">
                        <thead>
                          <tr>
                            <th class="text-center cabecalho-cinza">DATA DE ADESÃO</th>
                            <th class="text-center cabecalho-cinza">VIGÊNCIA DO CONTRATO</th>
                            <th class="text-center cabecalho-cinza">PERÍODO DE VIGÊNCIA</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="bold text-center">Do dia 9 ao dia 23</td>
                            <td class="text-center bold">1</td>
                            <td class="text-center bold">01 a 30</td>
                          </tr>
                          <tr>
                            <td class="bold text-center">Do dia 24 ao dia 8</td>
                            <td class="text-center bold">15</td>
                            <td class="text-center bold">15 a 14</td>
                          </tr>
                        </tbody>
                      </table>

                      <!-- OUTROS -->
                      <table *ngIf="!heMedSenior" class="table table-bordered tabela-impressao-compacta">
                        <thead>
                          <tr>
                            <th class="text-center cabecalho-cinza">DATA DE ADESÃO</th>
                            <th class="text-center cabecalho-cinza">VIGÊNCIA DO CONTRATO</th>
                            <th
                              class="text-center cabecalho-cinza"
                              *ngIf="!dadosOperadoraCabecalho?.ehInclusaoDependente">
                              PAGAMENTO DA MENSALIDADE
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td class="bold text-center">
                              <ng-container [ngSwitch]="tipoCobranca">
                                <span *ngSwitchCase="'saude_inclusao_dependente'">Até o dia 10 de cada mês</span>
                                <span *ngSwitchCase="'udemo_apase'">Até o dia 10 de cada mês</span>
                                <span *ngSwitchCase="'odonto_comum'">Até o dia 15 de cada mês</span>
                                <span *ngSwitchCase="'odontoprev_inclusao_dependente'">Até o dia 15 de cada mês</span>
                                <span *ngSwitchDefault>Até o dia 14 de cada mês</span>
                              </ng-container>
                            </td>

                            <td class="text-center bold">
                              {{ mesReferencia }}
                            </td>

                            <td class="text-center bold" *ngIf="!dadosOperadoraCabecalho?.ehInclusaoDependente">
                              {{ dataVencimento }}
                            </td>
                          </tr>

                          <ng-container
                            *ngIf="!isOdonto() && !udemo_e_apase && !dadosOperadoraCabecalho?.ehInclusaoDependente">
                            <tr>
                              <td class="text-center bold">Dia 15 a 25 de cada mês</td>
                              <td class="text-center bold">15 do mês subsequente</td>
                              <td class="text-center bold">5º dia útil a partir da vigência</td>
                            </tr>
                            <tr>
                              <td class="text-center bold">26 a 31 de cada mês</td>
                              <td class="text-center bold">01 do segundo mês subsequente</td>
                              <td class="text-center bold">5º dia útil a partir da vigência</td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- FIM COLUNA DIREITA -->
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
